import Observer from './Observer';

/**
 * Represents Observable
 */
class Observable {
	private listeners: Observer[];

	/**
	 * @constructor
	 */
	constructor() {
		this.listeners = [];
	}

	/**
	 * Subscribe for updates
	 * @param {Observer} listener - listener
	 */
	subscribe(listener: Observer): void {
		if (typeof listener.update === 'function') {
			this.listeners.push(listener);
		}
	}

	/**
	 * Unsubscribe from updates
	 * @param {Observer} listenerToRemove - listenerToRemove
	 */
	unsubscribe(listenerToRemove: Observer): void {
		this.listeners = this.listeners.filter((listener) => listener !== listenerToRemove);
	}

	/**
	 * Unsubscribe all listeners from updates
	 */
	unsubscribeAll(): void {
		this.listeners = [];
	}

	/**
	 * Notify all listeners about updates
	 * @param {string | number} updateID - update id
	 * @param {object} data - data
	 */
	async notify(updateID: string | number, data: any): Promise<void> {
		for (const listener of this.listeners) {
			try {
				await listener.update(updateID, data);
			} catch (e) {
				console.error(e);
			}
		}
	}
}

export default Observable;
